import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './i18n';
import './lib/utils/strMethods';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ruLocale from 'date-fns/locale/ru';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { StylesProvider } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/core';
import { AuthStoreProvider } from 'context/AuthStore';
import { asterTheme } from 'asterX-UI';
import { ModalbarProvider } from 'modules/Modalbar';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import 'react-image-lightbox/style.css';

import { RecoilRoot } from 'recoil';
import RecoilNexus from 'recoil-nexus';

ReactDOM.render(
  <RecoilRoot>
    <RecoilNexus />
    <ThemeProvider theme={asterTheme}>
      <StylesProvider>
        <BrowserRouter>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ruLocale}>
            <SnackbarProvider
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              autoHideDuration={3000}
            >
              <ModalbarProvider>
                <Switch>
                  <Route
                    path='/'
                    render={(props) => (
                      <AuthStoreProvider {...props}>
                        <App {...props} />
                      </AuthStoreProvider>
                    )}
                  />
                </Switch>
              </ModalbarProvider>
            </SnackbarProvider>
          </MuiPickersUtilsProvider>
        </BrowserRouter>
      </StylesProvider>
    </ThemeProvider>
  </RecoilRoot>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
